import { ProgCss } from "../ProgCss.Generated";
import { cast, castOrNull } from "../tools";

export function registerStudentAanmeldingSupplementListeners(scopeEl: HTMLElement) {
    registerVraagListeners(scopeEl);
    registerVooropleidingDocListeners(scopeEl);
    registerVooropleidingLandListeners(scopeEl);
    registerVooropleidingListeners(scopeEl);
    InitScrollToEnd(scopeEl);
}

const MaxFileUploadSize_in_MB = 4;

function registerVraagListeners(scopeEl: HTMLElement) {
    for (const form of scopeEl.getElementsByClassName(ProgCss.js_StudentAanmeldingSupplementVraag_form)) {
        const uploads = form.getElementsByClassName(ProgCss.js_StudentAanmeldingSupplementVraag_file);
        const tekstElements = form.getElementsByClassName(ProgCss.js_StudentAanmeldingSupplementVraag_tekst);
        const submit = form.querySelector("button");

        form.addEventListener("input", () => {
            let answered = false;
            let uploadedFileIsTooLarge = false;

            for (const upload of uploads) {
                if (upload instanceof HTMLInputElement) {
                    if (upload.files!.length === 1) {
                        answered = true;
                    }
                    const tooLargeNotification = cast(form.getElementsByClassName(ProgCss.js_StudentAanmeldingSupplementVraag_file_too_large)[0], HTMLElement);
                    uploadedFileIsTooLarge = upload.files!.length === 1 && upload.files![0].size > MaxFileUploadSize_in_MB * 1024 * 1024;

                    if (uploadedFileIsTooLarge) {
                        tooLargeNotification.style.display = "block";
                    } else {
                        tooLargeNotification.style.display = "none";
                    }
                }
            }

            for (const tekstElement of tekstElements) {
                answered ||= (tekstElement instanceof HTMLSelectElement || tekstElement instanceof HTMLTextAreaElement) && !!tekstElement.value;
            }

            if (submit instanceof HTMLButtonElement) {
                submit.disabled = !answered || uploadedFileIsTooLarge;
            }
        });
    };
}

function registerVooropleidingDocListeners(scopeEl: HTMLElement) {
    for (const form of scopeEl.getElementsByClassName(ProgCss.js_StudentVooropleidingDocument_form)) {
        const vooropleidingDocumentTypeId = form.getElementsByClassName(ProgCss.js_VooropleidingDocumentTypeId)[0];
        const fileName = form.getElementsByClassName(ProgCss.js_filename)[0];
        const required = form.getElementsByClassName(ProgCss.js_StudentAanmeldingSupplementVraag_required)[0];
        const tooLarge = form.getElementsByClassName(ProgCss.js_StudentAanmeldingSupplementVraag_file_too_large)[0];
        const fileInput = form.querySelector("input[type=file]");
        const submit = form.querySelector("button:not([type=button])");

        form.addEventListener("change", () => {
            if (fileInput instanceof HTMLInputElement && fileInput.files
                && submit instanceof HTMLButtonElement
                && fileName
                && required instanceof HTMLElement
                && tooLarge instanceof HTMLElement
                && vooropleidingDocumentTypeId instanceof HTMLSelectElement
            ) {
                submit.disabled = !(vooropleidingDocumentTypeId.value.length > 0 && fileInput.files!.length === 1 && fileInput.files![0].size <= MaxFileUploadSize_in_MB * 1024 * 1024);
                fileName.textContent = fileInput.files.length === 1 ? fileInput.files[0].name : "";
                required.style.display = (fileInput.files.length !== 1) ? "block" : "none";
                tooLarge.style.display = (fileInput.files.length === 1 && fileInput.files[0].size > MaxFileUploadSize_in_MB * 1024 * 1024) ? "block" : "none";
            }
        });
    }
}

function registerVooropleidingLandListeners(scopeEl: HTMLElement): void {
    for (const form of scopeEl.getElementsByClassName(ProgCss.js_StudentVooropleidingLand_form)) {
        const landSelect = [...form.getElementsByClassName(ProgCss.js_land)].filter(el => el instanceof HTMLSelectElement)[0];
        const submitButton = cast(form.querySelector("button[type=submit]"), HTMLButtonElement);
        landSelect.addEventListener("change", OnLandChanged);
        OnLandChanged();

        function OnLandChanged() {
            submitButton.disabled = (landSelect.value === "0");
        }
    }
}

function InitScrollToEnd(scopeEl: HTMLElement) {
    for (const element of scopeEl.getElementsByClassName(ProgCss.js_scroll_to_end)) {
        element.scrollTop = element.scrollHeight;
    };
}

function registerVooropleidingListeners(scopeEl: HTMLElement): void {
    for (const form of scopeEl.getElementsByClassName(ProgCss.js_StudentVooropleiding_form)) {
        if (form instanceof HTMLFormElement) {
            InitStudentVooropleidingForm(form);
        }
    }
}

const VooropleidingNufficExtraKeuze = "-1";
const VooropleidingNufficOther = "0";

function InitStudentVooropleidingForm(form: HTMLFormElement): void {
    const vooropleidingSelect = castOrNull(form.getElementsByClassName(ProgCss.js_vooropleiding)[0], HTMLSelectElement);
    const vooropleidingNaamExtra = castOrNull(form.getElementsByClassName(ProgCss.js_vooropleiding_naam_extra)[0], HTMLInputElement);
    const vooropleidingNaamOther = castOrNull(form.getElementsByClassName(ProgCss.js_vooropleiding_other)[0], HTMLInputElement);
    const vooropleidingNaamOtherRow = vooropleidingNaamOther?.closest("tr");
    const vooropleidingSubmit = castOrNull(form.getElementsByClassName(ProgCss.js_VooropleidingSubmit)[0], HTMLButtonElement);

    if (vooropleidingSelect && vooropleidingNaamExtra && vooropleidingSubmit && vooropleidingNaamOther && vooropleidingNaamOtherRow) {
        const CheckFormSubmittable = () => {
            vooropleidingSubmit.disabled = (!vooropleidingSelect.value.trim()) || (vooropleidingSelect.value == VooropleidingNufficOther && !vooropleidingNaamOther.value.trim());
        }
        const OnVooropleidingSelectChanged = () => {
            vooropleidingNaamOtherRow.style.display = vooropleidingSelect.value === VooropleidingNufficOther ? "" : "none";
            vooropleidingNaamExtra.value = vooropleidingSelect.value == VooropleidingNufficExtraKeuze ? vooropleidingSelect.options[vooropleidingSelect.selectedIndex].text : "";
            CheckFormSubmittable();
        }
        vooropleidingSelect.addEventListener("change", () => OnVooropleidingSelectChanged());
        OnVooropleidingSelectChanged();
        form.addEventListener("change", () => CheckFormSubmittable());
    }
}


